import {
  contentVisualPreviewEmptyImageElement,
  contentVisualPreviewImageElement,
} from '@cohort/components-xps/components/contents/apps/utils';
import {SpotifyLogo} from '@phosphor-icons/react';

type SpotifyPlaylistVisualPreviewContentProps = {
  thumbnailUrl: string | null;
  title: string;
  className?: string;
};

const SpotifyPlaylistVisualPreviewContent: React.FC<SpotifyPlaylistVisualPreviewContentProps> = ({
  thumbnailUrl,
  title,
  className,
}) => {
  return thumbnailUrl
    ? contentVisualPreviewImageElement(title, thumbnailUrl, className)
    : contentVisualPreviewEmptyImageElement(<SpotifyLogo />, className);
};

export default SpotifyPlaylistVisualPreviewContent;
